import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import './Navbar.css'
import hamburger from '../assets/hamburger.png'

const CustomNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const toggleMenu = () => setMenuOpen(!menuOpen)
  const closeMenu = () => setMenuOpen(false)

  useEffect(() => {
    const handleScroll = () => {
      const hero = document.querySelector('.hero-section')
      const heroHeight = hero?.offsetHeight || 0
      setScrolled(window.scrollY > heroHeight)
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <nav className={`custom-navbar ${scrolled ? 'scrolled' : 'transparent'}`}>
      <div className='navbar-container'>
        {/* Logo */}
        <NavLink to='/' className='navbar-logo-link' onClick={closeMenu}>
          <img src='/amthill.png' alt='Logo' className='navbar-logo' />
        </NavLink>

        {/* Main Navigation Links */}
        <div className='navbar-links'>
          <NavLink to='/' onClick={closeMenu}>
            Home
          </NavLink>
          <NavLink to='/our-story' onClick={closeMenu}>
            Our Story
          </NavLink>
          <NavLink to='/the-farm' onClick={closeMenu}>
            The Farm
          </NavLink>
          <NavLink to='/stays' onClick={closeMenu}>
            Stays
          </NavLink>
          <NavLink to='/experiences' onClick={closeMenu}>
            Experiences
          </NavLink>
          <NavLink to='/gallery' onClick={closeMenu}>
            Gallery
          </NavLink>
          <NavLink to='/plan-your-journey' onClick={closeMenu}>
            Plan Your Journey
          </NavLink>
          <NavLink to='/contact' onClick={closeMenu}>
            Contact
          </NavLink>
        </div>

        {/* Hamburger Toggle */}
        <div className='navbar-icons'>
          <div className='icon-circle menu-toggle' onClick={toggleMenu}>
            <img
              src={hamburger}
              alt='menu'
              className={scrolled ? 'icon-scrolled' : ''}
            />
          </div>
        </div>
      </div>

      {/* Right Drawer Menu (for small screens) */}
      <div className={`drawer-menu ${menuOpen ? 'open' : ''}`}>
        <button className='close-btn' onClick={closeMenu}>
          ×
        </button>
        <NavLink to='/' onClick={closeMenu}>
          Home
        </NavLink>
        <NavLink to='/our-story' onClick={closeMenu}>
          Our Story
        </NavLink>
        <NavLink to='/the-farm' onClick={closeMenu}>
          The Farm
        </NavLink>
        <NavLink to='/stays' onClick={closeMenu}>
          Stays
        </NavLink>
        <NavLink to='/experiences' onClick={closeMenu}>
          Experiences
        </NavLink>
        <NavLink to='/gallery' onClick={closeMenu}>
          Gallery
        </NavLink>
        <NavLink to='/plan-your-journey' onClick={closeMenu}>
          Plan Your Journey
        </NavLink>
        <NavLink to='/contact' onClick={closeMenu}>
          Contact
        </NavLink>
      </div>

      {menuOpen && <div className='overlay' onClick={closeMenu}></div>}
    </nav>
  )
}

export default CustomNavbar
